export const productTypes = {
  lesson: {
    shopifyProductType: 'Pamokos',
    shopifyProductTypeRo: 'Lecții',
    type: 'lesson',
    titleString: 'lessons',
    bgColor: '#f2f6ff',
  },
  material: {
    shopifyProductType: 'Mokomoji medžiaga',
    shopifyProductTypeRo: 'Material educativ',
    type: 'material',
    titleString: 'teachingMaterial',
    bgColor: '#f8f8f8',
  },
  seminar: {
    shopifyProductType: 'Seminarai',
    shopifyProductTypeRo: 'Seminarii',
    type: 'seminar',
    titleString: 'seminars',
    bgColor: '',
  },
};
